export default class SavedData{
	constructor() {
		/**
		 * @type {String}
		 * @const
		 */
		this.SAVE_NAME = 'customer_focus';
		this.SAVE_VERSION = '0.0.18';
		this.SAVE_SEED = 'y5k0Eo6R177mUkb';

		/**
		 * @type {Boolean}
		 */
		this._isToolTutorial = true;
		this._isDrawTutorial = true;
		this._isPaletteTutorial = true;
	}

	init() {
		if (!window.localStorage[ this.SAVE_NAME + '_' + this.SAVE_VERSION ]){
			this.reset();
			this.save();
		}
		else
			this.load();

	}

	reset(){
		this._isToolTutorial = true;
		this._isDrawTutorial = true;
		this._isPaletteTutorial = true;
	}

	load(){
		let data = window.localStorage[this.SAVE_NAME + '_' + this.SAVE_VERSION];
		data = JSON.parse( data );

		this._isToolTutorial 			= data.isToolTutorial;
		this._isDrawTutorial 			= data.isDrawTutorial;
		this._isPaletteTutorial 		= data.isPaletteTutorial;
	}

	save(){
		let data = {};
		data.isToolTutorial 		= this._isToolTutorial;
		data.isDrawTutorial 		= this._isDrawTutorial;
		data.isPaletteTutorial 		= this._isPaletteTutorial;

		const json = JSON.stringify( data );
		data.hash = P3.utils.md5( json + this.SAVE_SEED );

		window.localStorage[ this.SAVE_NAME + '_' + this.SAVE_VERSION ] = JSON.stringify( data );
	}

	get isToolTutorial() {
		return this._isToolTutorial;
	}

	set isToolTutorial(value) {
		this._isToolTutorial = value;
	}

	get isDrawTutorial() {
		return this._isDrawTutorial;
	}

	set isDrawTutorial(value) {
		this._isDrawTutorial = value;
	}

	get isPaletteTutorial() {
		return this._isPaletteTutorial;
	}

	set isPaletteTutorial(value) {
		this._isPaletteTutorial = value;
	}
}